import { FC } from 'react';
import {
  BarcodeIcon,
  CreditCardIcon,
  ExternalLinkIcon,
  IconProps,
  MoneyIcon,
  PixIcon,
  ShoppingCartIcon,
} from '@nimbus-ds/icons';
import { ConceptCode } from '@tiendanube/common';
import { CheckoutPaymentMethod } from '@tiendanube/common/src/enums';

const PAYMENT_METHOD_ICON_MAP: Record<CheckoutPaymentMethod, FC<IconProps>> = {
  cc: CreditCardIcon,
  transfer: MoneyIcon,
  ticket: ShoppingCartIcon,
  'mp-cc': CreditCardIcon,
  'mp-dc': CreditCardIcon,
  'mp-bank-transfer': PixIcon,
  'mp-boleto': BarcodeIcon,
  'mp-ticket': BarcodeIcon,
  'mp-balance': ExternalLinkIcon,
};

const MERCADO_PAGO_PAYMENT_METHODS: CheckoutPaymentMethod[] = [
  CheckoutPaymentMethod.MP_BANK_TRANSFER,
  CheckoutPaymentMethod.MP_BOLETO,
  CheckoutPaymentMethod.TICKET,
  CheckoutPaymentMethod.MP_CC,
  CheckoutPaymentMethod.MP_DC,
  CheckoutPaymentMethod.MP_TICKET,
];

export const FEE_CONCEPTS: ConceptCode[] = [
  'shipping-mercadopago-fee',
  'ar-shipping-mercadopago-fee',
];

export function getIconForPaymentMethod(method: CheckoutPaymentMethod) {
  return PAYMENT_METHOD_ICON_MAP[method];
}

export function paymentMethodIsMercadoPago(method: CheckoutPaymentMethod) {
  return MERCADO_PAGO_PAYMENT_METHODS.includes(method);
}

export function isAppRelatedConcept(concept: ConceptCode) {
  return concept === 'app-cost' || concept === 'app-extra-fee';
}

export function matchesConcept(
  targetConcept: ConceptCode,
  concept: ConceptCode,
  targetExternalReference?: string,
  externalReference?: string,
) {
  const sameConcept = concept === targetConcept;
  const sameExternalReference = externalReference === targetExternalReference;

  return (
    sameConcept &&
    (!isAppRelatedConcept(concept) ||
      !targetExternalReference ||
      !externalReference ||
      sameExternalReference)
  );
}
